import styled from 'styled-components';

export const ChatPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 200px);
  width: 100%;
`;

export const ChatPanelContent = styled.div`
  display: flex;
  flex-direction: column;  
  height: calc(100% - 100px);
  gap: 16px;
  width: 100%;
  
`;

export const MessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  
  
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  padding: 0px 4px;
  justify-content: ${(props) => (props.$isUser ? 'flex-end' : 'flex-start')};
`;

export const MessageBubble = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 8px;
  border-radius: 8px;
  background-color: ${(props) =>
    props.$type === 'user'
      ? '#F6F9FF'
      : '#FFFFFF'};
`;

export const InputContainer = styled.div`
  padding: 16px;
  position: absolute;
  overflow: visible;
  width: 100%;
  bottom: 0;
  left: 0;
`;

